
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30928',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30928",
  "emoji-mart": "static-3.6",
  "feedback-schema": "static-1.55502",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8451",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11903",
  "I18n": "static-7.1691",
  "quartz": "static-1.7584",
  "quartz-config": "static-1.1362",
  "quartz-core": "static-1.6803",
  "react-dlb": "static-1.92",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.83",
  "reselect": "static-3.15",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1033",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55489",
  "feedback-utils": "static-1.55493",
  "forms-embed-utils-lib": "static-1.4878",
  "forms-utils-lib": "static-1.13244",
  "foundations-assets": "static-1.5299",
  "foundations-components": "static-1.8652",
  "foundations-theming": "static-1.4893",
  "hub-http": "static-1.6622",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12210",
  "icons": "static-2.699",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4191",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17145",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5622",
  "react-virtualized": "static-2.111",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.512",
  "tinymce-plugins": "static-1.58405",
  "transmute": "static-2.97",
  "ui-images": "static-2.1269",
  "UIComponents": "static-3.8849",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3861",
  "quartz-webpack": "static-1.3808",
  "foundations-theming-specialty": "static-1.2609",
  "property-description-translator": "static-1.4234",
  "HeadJS": "static-2.811",
  "framer-motion": "static-1.83",
  "hs-test-utils-bend-plugin": "static-1.3562",
  "msw": "static-1.39",
  "msw-config": "static-1.16",
  "testing-library": "static-1.163",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4721",
  "jasmine-runner": "static-1.6860",
  "opentelemetry-fe-types": "static-1.197",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.896",
  "hubspotter-http": "static-1.4927",
  "mobile-manifest-mixins": "static-1.593",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.572",
  "quartz-auth": "static-1.1259",
  "quartz-head": "static-1.1249",
  "quartz-i18n": "static-1.1259",
  "quartz-routing": "static-1.1014",
  "quartz-test": "static-1.1259",
  "quartz-tracking": "static-1.963",
  "trellis-components": "static-1.2955",
  "ui-fonts": "static-1.1165",
  "usage-tracker-container": "static-1.7716",
  "usage-tracker-core": "static-1.7576",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.301",
  "conversations-skeleton-state": "static-1.7602",
  "reference-resolvers": "static-1.8593",
  "sanitize-text": "static-1.8570",
  "PatternValidationJS": "static-1.3300",
  "ReduxMessenger": "static-2.10783",
  "outpost": "static-1.4547",
  "rpc-client-utils": "static-1.5081",
  "sanitize": "static-1.4884",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4921",
  "floating-ui": "static-1.67",
  "hs-story-utils": "static-1.9838",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.88",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.2936",
  "bend-plugin-foundations-theming": "static-1.3376",
  "foundations-theming-base": "static-1.3878",
  "stylex": "static-1.45",
  "hs-locale-management": "static-1.360",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "ai-components-ui-library": "static-1.9918",
  "atom": "static-1.5490",
  "codemirror": "static-5.105",
  "content-assistance-lib": "static-1.8338",
  "ContentUtils": "static-1.69337",
  "data-token-picker": "static-1.17039",
  "file-manager-components": "static-1.24733",
  "FileManagerCore": "static-1.40232",
  "FileManagerLib": "static-1.40373",
  "frontend-preferences-client": "static-1.8331",
  "hub-http-contrib": "static-1.3439",
  "interframe": "static-3.5154",
  "layout-dnd-components": "static-1.13125",
  "layout-dnd-utils": "static-1.12100",
  "property-translator": "static-1.5793",
  "react-codemirror": "static-1.11052",
  "react-colorpicker": "static-2.10624",
  "reference-resolvers-lite": "static-1.8518",
  "rich-text-lib": "static-1.20463",
  "tinymce-data": "static-1.41376",
  "tinymce-themes": "static-1.57261",
  "ui-addon-emoji-picker": "static-1.10280",
  "ui-addon-sales-email": "static-1.5616",
  "ui-brand-identity-lib": "static-1.16782",
  "bender-build-tools": "static-1.3472",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.113",
  "hub-http-shared-msw-handlers": "static-1.10797",
  "hubspotter-http-shared-msw-handlers": "static-1.10795",
  "usage-tracker-session-replay": "static-1.5412",
  "base-ui": "static-1.26",
  "react-day-picker": "static-1.14",
  "trellis-theming": "static-1.1393",
  "tanstack-virtual": "static-1.42",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.491",
  "chirp-fetch": "static-1.2312",
  "stylex-utils": "static-1.158",
  "chatspot-core": "static-1.23477",
  "copilot-toolkit": "static-1.12038",
  "customer-data-objects-ui-components": "static-1.13442",
  "data-fetching-client": "static-1.10058",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5171",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29500",
  "usage-tracker": "static-1.7726",
  "cms-field-types": "static-1.5225",
  "content-icons-ui": "static-1.2417",
  "integrations-lib": "static-1.17293",
  "customer-data-objects": "static-1.8105",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.2001",
  "apollo-link-hub-http": "static-2.5019",
  "apollo-stack-hubspot": "static-3.98",
  "graphql": "static-1.92",
  "immer": "static-1.104",
  "immerable": "static-1.4555",
  "poll-commands": "static-1.3885",
  "ui-addon-iframeable": "static-1.9491",
  "video-components-external": "static-1.12323",
  "video-data-lib": "static-1.35981",
  "breeze-artifacts-sdk": "static-1.669",
  "audio-components": "static-1.6486",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29968",
  "FileManagerImages": "static-1.37884",
  "foundations-components-legacy": "static-1.1677",
  "html-to-image": "static-1.64",
  "redux-toolkit": "static-1.81",
  "salesImages": "static-1.671",
  "ui-universal-auth": "static-1.9615",
  "urlinator": "static-1.4928",
  "video-components": "static-1.14325",
  "video-embed": "static-1.36815",
  "ts-schema": "static-1.4360",
  "ContentData": "static-1.69412",
  "layout-data-lib": "static-1.10425",
  "react-dnd-compat": "static-1.5024",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1958",
  "external-options-client-types": "static-1.4408",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6002",
  "hs-resources": "static-1.607",
  "inbound-db-properties-service-client": "static-1.4108",
  "NamespacedHubStyle": "static-2.9325",
  "growth-onboarding-confetti": "static-1.3476",
  "SharedI18nStrings": "static-1.186",
  "ui-addon-i18n": "static-1.11559",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5849",
  "magpie-types": "static-1.5309",
  "simple-logging-lib": "static-1.3465",
  "avatar-components": "static-1.2896",
  "customer-data-ui-utilities": "static-1.10244",
  "growth-onboarding-feedback-components": "static-1.6996",
  "flux-actions": "static-1.378",
  "hubspot-apollo-client": "static-1.5287",
  "integrations-error-boundary-lib": "static-1.14708",
  "integrations-tracking-lib": "static-1.6023",
  "laboratory-lib": "static-3.7563",
  "native-integrations-shared-strings": "static-1.8175",
  "redux-observable": "static-1.78",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10686",
  "unified-auth": "static-1.1129",
  "breeze-engine-chat-components": "static-1.979",
  "breeze-engine-core": "static-1.1279",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "pulse": "static-1.1051",
  "navigation-messaging": "static-1.8378",
  "content-media-composition-data-lib": "static-1.13470",
  "content-media-compositions": "static-2.17477",
  "idb-keyval": "static-1.54",
  "media-bridge-lib": "static-1.19552",
  "nudge-client-utils": "static-1.3310",
  "unified-auth-core-lib": "static-1.1411",
  "social-insights-client-types": "static-1.22829",
  "advanced-menus-core": "static-1.15723",
  "advanced-menus-lib": "static-1.12512",
  "ExportDialog": "static-6.10787",
  "ui-memberships-settings-lib": "static-1.35071",
  "conditional-properties-service-client": "static-1.4082",
  "crm-pipelines-api-client-types": "static-1.4413",
  "event-emitter": "static-1.1372",
  "framework-builder-read-service-client": "static-1.4288",
  "fdsr-migration-layer": "static-1.427",
  "inbound-db-meta-service-client": "static-1.3740",
  "multi-currency-client-types": "static-1.3977",
  "foundations-components-test-utils": "static-1.6135",
  "reactive-lib": "static-1.1135",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.746",
  "universal-page-editor-lib": "static-1.3423",
  "adobe-sign-auth-lib": "static-1.659",
  "ads-unified-auth-lib": "static-1.1758",
  "custom-vendor-connection-lib": "static-1.179",
  "google-sheets-integration-lib": "static-1.1223",
  "microsoft-drive-auth-lib": "static-1.386",
  "surveymonkey-integration-lib": "static-1.755",
  "slack-ui-library": "static-1.10810",
  "bend-plugin-pulse": "static-1.554",
  "fast-json-patch": "static-1.73",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3067",
  "nudge-renderer-utils": "static-1.3386",
  "onboarding-tours": "static-1.17300",
  "whisper-core-api": "static-1.7526",
  "fsm": "static-1.4166",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15722",
  "simple-menus-lib": "static-1.17239",
  "settings-ui-lib": "static-1.12941",
  "persist-promise": "static-1.4115",
  "crm-record-cards-service-types": "static-1.3834",
  "framework-data-schema-resolvers": "static-1.7308",
  "location-customization-utils-lib": "static-1.10310",
  "getting-started-shared-tasks": "static-1.19456",
  "growth-data-modal": "static-1.6044",
  "growth-onboarding-next-action-utils": "static-1.2881",
  "navigation-components": "static-1.19051",
  "onboarding-tours-client": "static-1.5515",
  "onboarding-tours-utils": "static-1.1367",
  "ui-shepherd-tracker": "static-1.8067",
  "user-context": "static-1.5476",
  "react-flip-move": "static-1.82",
  "framework-data-schema-quick-fetch": "static-1.7213",
  "onboarding-data-sync-lib": "static-1.2733",
  "growth-onboarding-next-action-components": "static-1.2909",
  "user-context-client": "static-1.4921",
  "nest": "static-1.648",
  "getting-started-shared-tasks-store": "static-1.18574",
  "InboxConnectUtils": "static-4.15742",
  "meetings-connect-utils-lib": "static-1.8028",
  "onboarding-scopes": "static-1.6864"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30928",
  "emoji-mart": "/emoji-mart/static-3.6",
  "feedback-schema": "/feedback-schema/static-1.55502",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8451",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11903",
  "I18n": "/I18n/static-7.1691",
  "quartz": "/quartz/static-1.7584",
  "quartz-config": "/quartz-config/static-1.1362",
  "quartz-core": "/quartz-core/static-1.6803",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.83",
  "reselect": "/reselect/static-3.15",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1033",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55489",
  "feedback-utils": "/feedback-utils/static-1.55493",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4878",
  "forms-utils-lib": "/forms-utils-lib/static-1.13244",
  "foundations-assets": "/foundations-assets/static-1.5299",
  "foundations-components": "/foundations-components/static-1.8652",
  "foundations-theming": "/foundations-theming/static-1.4893",
  "hub-http": "/hub-http/static-1.6622",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12210",
  "icons": "/icons/static-2.699",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4191",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17145",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5622",
  "react-virtualized": "/react-virtualized/static-2.111",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.512",
  "tinymce-plugins": "/tinymce-plugins/static-1.58405",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1269",
  "UIComponents": "/UIComponents/static-3.8849",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3861",
  "quartz-webpack": "/quartz-webpack/static-1.3808",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2609",
  "property-description-translator": "/property-description-translator/static-1.4234",
  "HeadJS": "/HeadJS/static-2.811",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3562",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.16",
  "testing-library": "/testing-library/static-1.163",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4721",
  "jasmine-runner": "/jasmine-runner/static-1.6860",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.197",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.896",
  "hubspotter-http": "/hubspotter-http/static-1.4927",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.593",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.572",
  "quartz-auth": "/quartz-auth/static-1.1259",
  "quartz-head": "/quartz-head/static-1.1249",
  "quartz-i18n": "/quartz-i18n/static-1.1259",
  "quartz-routing": "/quartz-routing/static-1.1014",
  "quartz-test": "/quartz-test/static-1.1259",
  "quartz-tracking": "/quartz-tracking/static-1.963",
  "trellis-components": "/trellis-components/static-1.2955",
  "ui-fonts": "/ui-fonts/static-1.1165",
  "usage-tracker-container": "/usage-tracker-container/static-1.7716",
  "usage-tracker-core": "/usage-tracker-core/static-1.7576",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.301",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "reference-resolvers": "/reference-resolvers/static-1.8593",
  "sanitize-text": "/sanitize-text/static-1.8570",
  "PatternValidationJS": "/PatternValidationJS/static-1.3300",
  "ReduxMessenger": "/ReduxMessenger/static-2.10783",
  "outpost": "/outpost/static-1.4547",
  "rpc-client-utils": "/rpc-client-utils/static-1.5081",
  "sanitize": "/sanitize/static-1.4884",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4921",
  "floating-ui": "/floating-ui/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9838",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.88",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.2936",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3376",
  "foundations-theming-base": "/foundations-theming-base/static-1.3878",
  "stylex": "/stylex/static-1.45",
  "hs-locale-management": "/hs-locale-management/static-1.360",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9918",
  "atom": "/atom/static-1.5490",
  "codemirror": "/codemirror/static-5.105",
  "content-assistance-lib": "/content-assistance-lib/static-1.8338",
  "ContentUtils": "/ContentUtils/static-1.69337",
  "data-token-picker": "/data-token-picker/static-1.17039",
  "file-manager-components": "/file-manager-components/static-1.24733",
  "FileManagerCore": "/FileManagerCore/static-1.40232",
  "FileManagerLib": "/FileManagerLib/static-1.40373",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8331",
  "hub-http-contrib": "/hub-http-contrib/static-1.3439",
  "interframe": "/interframe/static-3.5154",
  "layout-dnd-components": "/layout-dnd-components/static-1.13125",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12100",
  "property-translator": "/property-translator/static-1.5793",
  "react-codemirror": "/react-codemirror/static-1.11052",
  "react-colorpicker": "/react-colorpicker/static-2.10624",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8518",
  "rich-text-lib": "/rich-text-lib/static-1.20463",
  "tinymce-data": "/tinymce-data/static-1.41376",
  "tinymce-themes": "/tinymce-themes/static-1.57261",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10280",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5616",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16782",
  "bender-build-tools": "/bender-build-tools/static-1.3472",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.113",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10797",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10795",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5412",
  "base-ui": "/base-ui/static-1.26",
  "react-day-picker": "/react-day-picker/static-1.14",
  "trellis-theming": "/trellis-theming/static-1.1393",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.491",
  "chirp-fetch": "/chirp-fetch/static-1.2312",
  "stylex-utils": "/stylex-utils/static-1.158",
  "chatspot-core": "/chatspot-core/static-1.23477",
  "copilot-toolkit": "/copilot-toolkit/static-1.12038",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13442",
  "data-fetching-client": "/data-fetching-client/static-1.10058",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5171",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29500",
  "usage-tracker": "/usage-tracker/static-1.7726",
  "cms-field-types": "/cms-field-types/static-1.5225",
  "content-icons-ui": "/content-icons-ui/static-1.2417",
  "integrations-lib": "/integrations-lib/static-1.17293",
  "customer-data-objects": "/customer-data-objects/static-1.8105",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2001",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5019",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.98",
  "graphql": "/graphql/static-1.92",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4555",
  "poll-commands": "/poll-commands/static-1.3885",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9491",
  "video-components-external": "/video-components-external/static-1.12323",
  "video-data-lib": "/video-data-lib/static-1.35981",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.669",
  "audio-components": "/audio-components/static-1.6486",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29968",
  "FileManagerImages": "/FileManagerImages/static-1.37884",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1677",
  "html-to-image": "/html-to-image/static-1.64",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "salesImages": "/salesImages/static-1.671",
  "ui-universal-auth": "/ui-universal-auth/static-1.9615",
  "urlinator": "/urlinator/static-1.4928",
  "video-components": "/video-components/static-1.14325",
  "video-embed": "/video-embed/static-1.36815",
  "ts-schema": "/ts-schema/static-1.4360",
  "ContentData": "/ContentData/static-1.69412",
  "layout-data-lib": "/layout-data-lib/static-1.10425",
  "react-dnd-compat": "/react-dnd-compat/static-1.5024",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1958",
  "external-options-client-types": "/external-options-client-types/static-1.4408",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6002",
  "hs-resources": "/hs-resources/static-1.607",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4108",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9325",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3476",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11559",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5849",
  "magpie-types": "/magpie-types/static-1.5309",
  "simple-logging-lib": "/simple-logging-lib/static-1.3465",
  "avatar-components": "/avatar-components/static-1.2896",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10244",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6996",
  "flux-actions": "/flux-actions/static-1.378",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5287",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14708",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6023",
  "laboratory-lib": "/laboratory-lib/static-3.7563",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8175",
  "redux-observable": "/redux-observable/static-1.78",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10686",
  "unified-auth": "/unified-auth/static-1.1129",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.979",
  "breeze-engine-core": "/breeze-engine-core/static-1.1279",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "pulse": "/pulse/static-1.1051",
  "navigation-messaging": "/navigation-messaging/static-1.8378",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13470",
  "content-media-compositions": "/content-media-compositions/static-2.17477",
  "idb-keyval": "/idb-keyval/static-1.54",
  "media-bridge-lib": "/media-bridge-lib/static-1.19552",
  "nudge-client-utils": "/nudge-client-utils/static-1.3310",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1411",
  "social-insights-client-types": "/social-insights-client-types/static-1.22829",
  "advanced-menus-core": "/advanced-menus-core/static-1.15723",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12512",
  "ExportDialog": "/ExportDialog/static-6.10787",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35071",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4082",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4413",
  "event-emitter": "/event-emitter/static-1.1372",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4288",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.427",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3740",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3977",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6135",
  "reactive-lib": "/reactive-lib/static-1.1135",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.746",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3423",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.659",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1758",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.179",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1223",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.386",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.755",
  "slack-ui-library": "/slack-ui-library/static-1.10810",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.554",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3067",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3386",
  "onboarding-tours": "/onboarding-tours/static-1.17300",
  "whisper-core-api": "/whisper-core-api/static-1.7526",
  "fsm": "/fsm/static-1.4166",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15722",
  "simple-menus-lib": "/simple-menus-lib/static-1.17239",
  "settings-ui-lib": "/settings-ui-lib/static-1.12941",
  "persist-promise": "/persist-promise/static-1.4115",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3834",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7308",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10310",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19456",
  "growth-data-modal": "/growth-data-modal/static-1.6044",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2881",
  "navigation-components": "/navigation-components/static-1.19051",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5515",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1367",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8067",
  "user-context": "/user-context/static-1.5476",
  "react-flip-move": "/react-flip-move/static-1.82",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7213",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2733",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2909",
  "user-context-client": "/user-context-client/static-1.4921",
  "nest": "/nest/static-1.648",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18574",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15742",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8028",
  "onboarding-scopes": "/onboarding-scopes/static-1.6864"
}
};
